import WarpElement from "@warp-ds/elements-core";
import "@warp-ds/elements/components/card";
import { css, html } from "lit";

class WithFullWidthBg extends WarpElement {
    declare class: string;
    declare last: boolean;

    static properties = {
        class: { attribute: true, type: String },
        last: { attribute: true, type: Boolean },
    };

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-8e-c4w;
        `,
    ];

    constructor() {
        super();
    }

    render() {
        return html`<div class="${this.class} w-screen relative" style="left: 50%; transform: translateX(-50%); max-width: none;">
            <div class="container">
                <slot></slot>
                </div>
            </div>
        </div>`;
    }
}

customElements.define("mfp-with-fullwidth-bg", WithFullWidthBg as unknown as CustomElementConstructor);
